@if(!showDetails){
<div class="main-container">
    <div class="title">
        <span class="title-text">Profile & Identity</span>
        <p class="small-title">
            Enter worker family code to proceed with the search.
        </p>
    </div>

    <form [formGroup]="searchForm" (ngSubmit)="searchByFamilyCode()">
        <div class="searchBar">
            <input type="text" maxlength="12" class="searchInput ac-input-control" placeholder="Enter family code"
                formControlName="familyCode" />

            <div class="btn">
                <button type="button" class="ac-secondary-btn" (click)="reset()">
                    Reset
                </button>
                <button type="submit" class="ac-primary-btn" [disabled]="searchForm.invalid">
                    Search
                </button>
            </div>
        </div>
    </form>

    @if(workerList.length > 0){
        @if(!isMobile){
    <div class="table-container">
        <table class="table">
            <thead class="table-head">
                <tr>
                    <th>Name</th>
                    <th>Gender</th>
                    <th>Family Code</th>
                    <th>Mobile Number</th>
                    <th>Status</th>
                </tr>
            </thead>

            <tbody class="table-body">
                @for(row of workerList; track row){
                <tr (click)="getWorkerDetails(row.devoteeFamilyCode)">
                    <td>
                        {{ row.devoteeFirstName }}
                        {{ row.devoteeMiddleName || '' }}
                        {{ row.devoteeLastName }}
                    </td>
                    <td>{{ row.gender }}</td>
                    <td>{{ row.devoteeFamilyCode }}</td>
                    <td>{{ row.mobileNumber }}</td>
                    <td>{{ row.status }}</td>
                </tr>
                }
            </tbody>
        </table>
    </div>
        }

  @if(isMobile){
  <div class="mobile-card-list">
    @for(row of workerList; track row){
    <div class="mobile-card" (click)="getWorkerDetails(row.devoteeFamilyCode)">
      <div class="mc-name">{{ row.devoteeFirstName }} {{ row.devoteeMiddleName || '' }} {{ row.devoteeLastName }}</div>
      <div class="mc-row"><span class="mc-label">Gender</span><span class="mc-value">{{ row.gender }}</span></div>
      <div class="mc-row"><span class="mc-label">Family Code</span><span class="mc-value">{{ row.devoteeFamilyCode }}</span></div>
      <div class="mc-row"><span class="mc-label">Mobile</span><span class="mc-value">{{ row.mobileNumber }}</span></div>
      <div class="mc-row"><span class="mc-label">Status</span><span class="mc-value">{{ row.status }}</span></div>
    </div>
    }
  </div>
  }


    } @else {
    <div class="list-div">
        <div class="img-div">
            <img style="width: 150px;" src="icons/search_placeholder_dark.png" alt="">
            <span class="drop-title" style="text-align: end;">No Data Found</span>
        </div>
    </div>
    }
</div>
}
@else {
<div class="main-container">
    <div class="title">
        <span class="back-btn" style="color: var(--brand-primary); cursor: pointer" (click)="back()">
            <img src="icons/back-arrow-icon.svg" style="height: 15px; width: 15px;">
            Go back
        </span>
        <span class="title-text">
            Edit Profile & Identity Details - ({{ workerDetails[0]?.devoteeFamilyCode }})
        </span>
    </div>

    <div class="split-container">

        <div class="left-panel">

            <div class="section-header">
                <span class="section-title">
                    Accommodation Data
                </span>
            </div>

            <div class="card-details">
                @for(item of workerDetails; track item){
                <div class="family-details-accomodation" [class.is-primary]="item.isPrimaryDevotee">

                    <div class="details">
                        <div class="name-row">

                            @if(item.isPrimaryDevotee){
                            <div class="primary-devotee">
                                <span class="common-text">
                                    {{ item.devoteeFirstName }} {{ item.devoteeLastName }}


                                    @if(item.workerType){
                                    <span class="worker-type">({{ item.workerType }})</span>
                                    }
                                </span>


                                <img src="icons/verified-badge-line.png" style="width: 20px; height: 20px;"
                                    alt="badge-img">


                                 @if(!isMobile){
                    <div class="pending-design">
                        <span class="pending">Primary Devotee</span>
                    </div>
                    }
                                <img src="icons/edit-line.png" class="edit-icon" alt="edit" (click)="editName(item)" />

                            </div>
                            }
                            @else {
                            <span class="common-text">
                                {{ item.devoteeFirstName }} {{ item.devoteeLastName }}
                                @if(item.workerType){
                                <span class="worker-type">({{ item.workerType }})</span>
                                }
                            </span>
                            <img src="icons/edit-line.png" class="edit-icon" alt="edit" (click)="editName(item)" />
                            }

                        </div>
                    </div>

                    <div class="details">
                        <span class="common-header">Mobile</span>
                        <span class="common-text">{{ item.mobileNumber }}
                             <img src="icons/edit-line.png" class="edit-icon" alt="edit" (click)="editNumber(item)" />
                        </span>


                    </div>

                    <div class="details">
                        <span class="common-header">Aadhaar</span>
                        <span class="common-text">{{ item.idNumber }}
                            <img src="icons/edit-line.png" class="edit-icon" alt="edit" (click)="editAadhaar(item)" />

                        </span>

                    </div>

                </div>
                }
            </div>
        </div>

        <div class="right-panel">

            <div class="section-header right">
                <span class="section-title">
                    Philanthropy Data
                </span>
            </div>

            <div class="family-details names-only-card">

                <div class="names-list">
                    @if(philanthropyMembers.length > 0){
                    @for(member of philanthropyMembers; track member){
                    <div class="name-item">
                        <span>{{ member.fullName }}</span>

                        @if(member.isWorker){
                        <span class="worker-chip">
                            {{ member.workerType }}
                        </span>
                        }
                    </div>
                    }
                    } @else {
                    <div class="name-item empty">
                        No philanthropy data found
                    </div>
                    }
                </div>

            </div>
        </div>

    </div>

</div>
}